export default "__VITE_ASSET__D8ycg70b__"